import axios, { AxiosResponse, isAxiosError } from "axios";
import { Paginated, RequestError } from "./api";
import { Acomodacao, AcomodacaoData } from "../../components";

const url = `${process.env.REACT_APP_URL}/acomodacoes`;

const add = async (idBarragem: number, value: Acomodacao): Promise<Acomodacao | RequestError> => {
  try {
    const data: AxiosResponse<AcomodacaoData> = await axios.post(
      `${url}/${idBarragem}`,
      value.properties
    );
    return processData(data.data);
  } catch (error) {
    if (isAxiosError(error)) {
      return {
        error: error.response?.data.error ?? "Acomodação Error",
        message:
          error.response?.data.message ?? "Erro ao adicionar esta acomodação",
      };
    } else {
      throw error;
    }
  }
};

const getAll = async (idBarragem: number, page: number, perPage: number): Promise<Paginated<Acomodacao> | RequestError> => {
  try {
    const data: AxiosResponse<Paginated<AcomodacaoData>> = await axios.get(
      `${url}/all/${idBarragem}/${page}/${perPage}`
    );
    return {
      ...data.data,
      items: data.data.items.map(processData),
    };
  } catch (error) {
    if (isAxiosError(error)) {
      return {
        error: error.response?.data.error ?? "Acomodação Error",
        message: error.response?.data.message ?? "Erro ao obter acomodações",
      };
    } else {
      throw error;
    }
  }
};

const getById = async (idAcomodacao: number): Promise<Acomodacao | RequestError> => {
  try {
    const data: AxiosResponse<AcomodacaoData> = await axios.get(
      `${url}/${idAcomodacao}`
    );

    return processData(data.data);
  } catch (error) {
    if (isAxiosError(error)) {
      return {
        error: error.response?.data.error ?? "Acomodação Error",
        message: error.response?.data.message ?? "Erro ao obter acomodação",
      };
    } else {
      throw error;
    }
  }
};

const update = async (value: Acomodacao): Promise<Acomodacao | RequestError> => {
  try {
    const data: AxiosResponse<AcomodacaoData> = await axios.put(`${url}/${value.properties.id}`, value.properties);
    return processData(data.data);
  } catch (error) {
    if (isAxiosError(error)) {
      return {
        error: error.response?.data.error ?? "Acomodação Error",
        message:
          error.response?.data.message ?? "Erro ao atualizar acomodação",
      };
    } else {
      throw error;
    }
  }
};

const remove = async (idAcomodacao: number): Promise<Acomodacao | RequestError> => {
  try {
    const data: AxiosResponse<AcomodacaoData> = await axios.delete(`${url}/${idAcomodacao}`);
    return processData(data.data);
  } catch (error) {
    if (isAxiosError(error)) {
      return {
        error: error.response?.data.error ?? "Acomodação Error",
        message: error.response?.data.message ?? "Erro ao excluir acomodação",
      };
    } else {
      throw error;
    }
  }
};

function processData(value: AcomodacaoData) {
  value.dataCadastro = new Date(value.dataCadastro);
  value.dataModificacao &&= new Date(value.dataCadastro);
  return new Acomodacao(value, value.style);
}

export const ApiAcomodacao = {
  add,
  remove,
  update,
  getAll,
  getById,
};
